import { createFileRoute } from '@tanstack/react-router';
import ThrottleOnline from '../../../components/Graphs/Throttle';

export const Route = createFileRoute('/_authenticated/graphs/throttle/$vehicleId')({
  beforeLoad: ({ context }) => {
    // requirePermission(PERMISSION_RIDES, ['read']);
    return {
      ...context,
      documentTitle: {
        main: 'enum.onlineMap.widget.types.throttle',
        // suffix: 'menu.overviewTours',
      },
      isMenuDisabled: true,
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: ThrottleGraphRoute,
});

function ThrottleGraphRoute() {
  const { vehicleId } = Route.useParams();

  return <ThrottleOnline vehicleId={Number(vehicleId)} isPage />;
}
